module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-header__wrap cb-header__wrap--type3"
  }, [_c('div', {
    staticClass: "cb-header__title",
    style: (_vm.themeColor)
  }, [_vm._v("\n    \t" + _vm._s(_vm.header) + "\n    ")]), _vm._v(" "), (_vm.checkout_steps.length > 1) ? _c('div', {
    staticClass: "cb-header__wizard"
  }, _vm._l((_vm.checkout_steps), function(i) {
    return _c('div', {
      key: i,
      staticClass: "cb-header__button",
      class: {
        'cb-header__button--active': _vm.current_checkout_step == i
      },
      style: (_vm.backgroundColor)
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfab9e9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/headers/Type3.vue
// module id = 272
// module chunks = 66 69